export enum TopicLockType {
  Unknown = 0,
  Workflow = 1,
  Audit = 2,
  Index = 3,
  SharepointEditDocumentOnline = 4,
  OnlyOfficeEditDocumentOnline = 5,
  ChangeControlWorkflow = 6,
  EditDocumentOffline = 7,
  Redaction = 8,
  SentForRegeneration = 9,
}
